import DepositForm from './DepositForm';
import connect from './connect';

export default connect(DepositForm);



// WEBPACK FOOTER //
// ./src/components/DepositForm/index.js